// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
const NOT_SUPPORTED_RECOVERY_SUGGESTION = 'Passkeys may not be supported on this device. Ensure your application is running in a secure context (HTTPS) and Web Authentication API is supported.';

export { NOT_SUPPORTED_RECOVERY_SUGGESTION };
//# sourceMappingURL=passkeyErrorPlatformConstants.mjs.map
